module.exports = __webpack_public_path__ + "static/media/main27.a7bf1eef.png";